import { useTranslation } from 'react-i18next';
import { SubmissionError } from 'redux-form';

import { prepareFormData, notify, getApiFormError } from 'libs/common';
import { updateClientLk } from 'services/client-service';
import { Title } from '../client/personal-data.styled';
import { LkForm } from './ui/lk-form';
import { ZonesForm } from './ui/zones-form';
import { ToggleBox, Toggle, ToggleWrap, Buttons, Content, Zone, /*ZoneIcon,*/ ZoneInput, ZoneTitle, Block } from './lk.styled';

export const LK = (props) => {
  const { t } = useTranslation();

  const { client, clientId, refreshClient } = props;
  const login = client?.data?.lk_login;

  /**
   * save user
   * @param {*} data
   */
  const saveLk = async (data) => {
    // console.log('data', data);
    const out = { ...data, id: client.id };
    try {
      await updateClientLk(out);
      refreshClient();
      notify(t('messages.ВНИМАНИЕ!'), t('messages.Изменения сохранены'), 'success');
    } catch (error) {
      const submissionErrors = getApiFormError(error);
      throw new SubmissionError(submissionErrors);
    }
  };

  /**
   * prepare client data for form
   */
  const prepareLkData = () => {
    const out = { lk_unlimited: client.data?.lk_unlimited ?? '', lk_login: login };
    return prepareFormData(out);
  };

  const userData = prepareLkData();

  return (
    <Content>
      <Block>
        <Title className="nobrd">Пользователь</Title>
        <LkForm lk_login={login} onSubmit={saveLk} initialValues={userData} />
      </Block>
      <Block>
        <Title className="nobrd">Настройки</Title>
        <ZonesForm clientId={clientId} />
      </Block>
    </Content>
  );
};
